<p-table [value]="contacts">
    <ng-template pTemplate="header">
        <tr>
            <th>First name</th>
            <th>Last name</th>
            <th>Mobile</th>
            <th>Email</th>
            <th>Birth date</th>
            <th>I am</th>
            <th>Origin</th>
            <th>Newsletter</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-contact>
        <tr>
            <td>{{contact.firstName}}</td>
            <td>{{contact.lastName}}</td>
            <td>{{contact.mobileNumber}}</td>
            <td class="email-container">{{contact.email}}</td>
            <td>{{contact.birthDate | date:'dd/MM/yyyy'}}</td>
            <td>{{contact.iAm}}</td>
            <td>{{contact.origin}}</td>
            <td>
                <p-checkbox [binary]="true"[(ngModel)]="contact.allowNewsletter" [readonly]="true" *ngIf="contact.allowNewsletter"></p-checkbox>
            </td>
        </tr>
    </ng-template>
</p-table>